import $ from 'jquery'
require('jquery.marquee')

export function init() {
  setTimeout(() => {
    $('.marquee').marquee({
      allowCss3Support: true,
      startVisible: true,
      duplicated: true,
      speed: 75, // px per second
      gap: 0,
    })
  }, 500)
}
